import Vue from 'vue'
import VueI18n from 'vue-i18n'

Vue.use(VueI18n)

function loadLocaleMessages () {
  const locales = require.context('./locales', true, /[A-Za-z0-9-_,\s]+\.json$/i)
  const messages = {}
  locales.keys().forEach(key => {
    const matched = key.match(/([A-Za-z0-9-_]+)\./i)
    if (matched && matched.length > 1) {
      const locale = matched[1]
      messages[locale] = locales(key)
    }
  })
  return messages
}

function getBrowserLanguage() {

  const language = navigator.language.split('-')[0] 

  switch (language) {

    case 'en':
      return 'en';
      break;
    case 'es':
      return 'es';
      break;
    case 'fr':
      return 'fr';
      break;
    default:
      return 'en';
      break;
  }
}

export default new VueI18n({
  locale: getBrowserLanguage(),
  fallbackLocale: getBrowserLanguage(),
  messages: loadLocaleMessages()
})
